import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../lib/axiosInstance';
import { AxiosError } from 'axios';
import { AppErrorResponse } from '../types';

export function useDeletePOFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await axiosInstance.delete(`/purchase/orders/files?ids=${id}`);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useUploadPOFiles<T>() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: {
      id: string | null | undefined;
      formData: FormData;
    }) => {
      return await axiosInstance.putForm<T, AxiosError<AppErrorResponse>>(
        `/purchase/orders/${data.id}/upload`,
        data.formData,
      );
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}
